import { useState, useEffect } from "react";

export const NavBar = () => {
  const [sideNav, setSideNav] = useState(false);
  return (
    <div>
      <div className={sideNav ? "side-nav-on" : "side-nav-off"}>
        <div className="side-nav-container">
          <div className="navbar container">
            <div className="poppins-subtitle-1">Homieverse</div>

            <div className="set-mobile">
              <i
                className="fas fa-times fa-lg"
                onClick={() => {
                  sideNav ? setSideNav(false) : setSideNav(true);
                }}
              ></i>
            </div>
          </div>
          <div>
            <ul className="side-nav-mobile poppins-subtitle-2">
              <li>
                <a>Explore</a>
              </li>
              <li>
                <a>Team</a>
              </li>
              <li>
                <a>FAQ</a>
              </li>
              <li>
                <a>Join</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="navbar">
          <div className="poppins-subtitle-1">Homieverse</div>
          <div className="set-desktop">
            <ul className="nav-left poppins-subtitle-2">
              <li>
                <a>Explore</a>
              </li>
              <li>
                <a>Team</a>
              </li>
              <li>
                <a>FAQ</a>
              </li>
              <li>
                <a>Join</a>
              </li>
            </ul>
          </div>

          <div className="set-mobile">
            <i
              className="fas fa-bars fa-lg cursor-pointer"
              onClick={() => {
                sideNav ? setSideNav(false) : setSideNav(true);
              }}
            ></i>
          </div>
        </div>
      </div>
    </div>
  );
};
